import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48925fe4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-page-panel" }

import { ref } from 'vue';
import router from '@/router';
import HomePageButton from '../ui/buttons/home-page-button.vue';
import NewSupportCaseModal from '@/components/support-cases/new-support-case-modal.vue';
import { RouteNames } from '@/router/RouteNames';
import TenantSwitchIcon from '../icons/tenant-switch-icon.vue';
import LandlordSwitchIcon from '../icons/landlord-switch-icon.vue';
import PurchaserSwitchIcon from '../icons/purchaser-switch-icon.vue';
import UtilitySwitchIcon from '../icons/utility-switch-icon.vue';
import SupportCaseIcon from '../icons/support-case-icon.vue';
import NewSupportCaseIcon from '../icons/new-support-case-icon.vue';
import TenantSwitchingModal from '../switches/tenant-switching/tenant-switching-modal.vue';
import LandlordSwitchingModal from "@/components/switches/landlord-switching/landlord-switching-modal.vue";
import PurchasingSwitchingModal from '../switches/purchaser-switching/purchasing-switching-modal.vue';
import HelpIcon from '../icons/help-icon.vue';
import { openUtilitySwitchingHelp } from '@/utils/system/helpViewer';


export default /*#__PURE__*/_defineComponent({
  __name: 'utility-switching-agent-panel',
  setup(__props) {

const showNewTenantSwitchModal = ref(false);
const showLandlordSwitchModal = ref(false);
const showNewPurchaserSwitchModal = ref(false);

/** Handles the click event of the Switch to Tenant button */
const onSwitchToTenantClick = () => showNewTenantSwitchModal.value = true;

/** Handles the click event of the Switch to Landlord button */
const onSwitchToLandlordClick = () => showLandlordSwitchModal.value = true;

/** Handles the click event of the Switch to Purchaser button */
const onSwitchToPurchaserClick = () => showNewPurchaserSwitchModal.value = true;

/** Handles the click event of the Switchovers button */
const onSwitchoversClick = () => router.push({ name: RouteNames.UtilitySwitchesList });

/** Handles the click event of the Support Cases button */
const onSupportCasesClick = () => navigateToSupportCases();

/** Handles the click event of the Create Support Case button */
const onCreateSupportCaseClick = () => showNewSupportCaseModal.value = true;

const showNewSupportCaseModal = ref(false);

/** Handles the new case created event of the new support case modal */
const onNewSupportCaseCreated = () => navigateToSupportCases();

const navigateToSupportCases = () => router.push({ name: RouteNames.SupportCases });

/** Handles the click event of the Help button */
const onHelpClick = () => openUtilitySwitchingHelp();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(HomePageButton, {
        text: "Switch to Tenant",
        onClick: onSwitchToTenantClick,
        "back-color": "#1DA4A6",
        "watermark-color": "#68C2C3"
      }, {
        icon: _withCtx(() => [
          _createVNode(TenantSwitchIcon)
        ]),
        _: 1
      }),
      _createVNode(HomePageButton, {
        text: "Switch to Landlord",
        onClick: onSwitchToLandlordClick,
        "back-color": "#50B71D",
        "watermark-color": "#8ACF65",
        "icon-width": "90px",
        "watermark-width": "230px"
      }, {
        icon: _withCtx(() => [
          _createVNode(LandlordSwitchIcon)
        ]),
        _: 1
      }),
      _createVNode(HomePageButton, {
        text: "Switch to Purchaser",
        onClick: onSwitchToPurchaserClick,
        "back-color": "#8F48C8",
        "watermark-color": "#B684DB"
      }, {
        icon: _withCtx(() => [
          _createVNode(PurchaserSwitchIcon)
        ]),
        _: 1
      }),
      _createVNode(HomePageButton, {
        text: "Switches",
        onClick: onSwitchoversClick,
        "back-color": "#A13427",
        "watermark-color": "#C1776E",
        "icon-width": "70px",
        "watermark-width": "145px"
      }, {
        icon: _withCtx(() => [
          _createVNode(UtilitySwitchIcon)
        ]),
        _: 1
      }),
      _createVNode(HomePageButton, {
        text: "Support Cases",
        onClick: onSupportCasesClick,
        "back-color": "#E69C1F",
        "watermark-color": "#EEBE6C",
        "watermark-width": "175px"
      }, {
        icon: _withCtx(() => [
          _createVNode(SupportCaseIcon)
        ]),
        _: 1
      }),
      _createVNode(HomePageButton, {
        text: "Create Support Case",
        onClick: onCreateSupportCaseClick,
        "back-color": "#1176BC",
        "watermark-color": "#5FA3D2"
      }, {
        icon: _withCtx(() => [
          _createVNode(NewSupportCaseIcon)
        ]),
        _: 1
      }),
      _createVNode(HomePageButton, {
        text: "Help",
        "back-color": "rgb(120, 120, 120)",
        "watermark-color": "rgb(220, 220, 220)",
        onClick: onHelpClick
      }, {
        icon: _withCtx(() => [
          _createVNode(HelpIcon)
        ]),
        _: 1
      })
    ]),
    _createVNode(NewSupportCaseModal, {
      modelValue: showNewSupportCaseModal.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showNewSupportCaseModal).value = $event)),
      onNewCaseCreated: onNewSupportCaseCreated
    }, null, 8, ["modelValue"]),
    _createVNode(TenantSwitchingModal, {
      modelValue: showNewTenantSwitchModal.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showNewTenantSwitchModal).value = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(LandlordSwitchingModal, {
      modelValue: showLandlordSwitchModal.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showLandlordSwitchModal).value = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(PurchasingSwitchingModal, {
      modelValue: showNewPurchaserSwitchModal.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showNewPurchaserSwitchModal).value = $event))
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})